export const REVERT_LAND_NOT_OWNED_ERROR = "Land not owned'";
export const REVERT_DEPOSIT_NOT_DECLARED = "You didn't declare this land deposit";
export const REVERT_DEPOSIT_NOT_DONE_YET = "The land hasn't been deposited yet";
export const REVERT_NOT_LANDS_MIN_AMOUNT = "Minimum amount of lands to create an offer not met";
export const REVERT_NOT_LAND_OWNER = "User is not land owner";
export const REVERT_NOT_ALL_DEPOSITED = "You haven't deposited all the lands";
export const REVERT_MIN_ALLOWANCE_NOT_MET = "Minumum allowance to buy the block not met";
export const REVERT_DISPATCH = "Dispatched call failed with error";
export const REVERT_OFFER_NOT_OWNED = "This offer is not created by you";